import React from 'react';

interface MockTagProps {
  className?: string;
}

export const MockTag: React.FC<MockTagProps> = ({ className = '' }) => {
  return (
    <span
      title="Mock Data"
      className={`inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-[11px] font-bold uppercase tracking-wider text-amber-800 shadow-sm ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
      Mock
    </span>
  );
};

export default MockTag;
